import { PuzzleStarIcon } from './PuzzleStarIcon';

/**
 * author: Michael Irigoyen
 * id 0DA18E4C-075B-4DE5-A428-31FB0BA791E4
 * name puzzle-star
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/puzzle-star.svg
 * tags
 * - Gaming / RPG 
 */
export const PuzzleFavoriteIcon = PuzzleStarIcon;
export default PuzzleFavoriteIcon